// import React from 'react';
// import styled from 'styled-components';

// const PrivacyContainer = styled.div`
//   max-width: 900px;
//   margin: 50px auto;
//   padding: 20px;
//   font-family: 'Arial', sans-serif;
//   line-height: 1.6;
//   color: #333;

//   h1, h2 {
//     color: #007BFF;
//   }

//   h2 {
//     margin-top: 20px;
//   }

//   p {
//     margin-bottom: 15px;
//   }

//   ul {
//     margin: 15px 0;
//     padding-left: 20px;
//   }

//   @media (max-width: 768px) {
//     padding: 15px;
//   }
// `;

// const PrivacyPolicy = () => {
//   return (
//     <PrivacyContainer>
//       <h1>Privacy Policy</h1>
//       <p>GoSafari is committed to protecting your privacy. This Privacy Policy explains how we collect, use, share, and protect your personal information.</p>

//       <h2>1. Information We Collect</h2>
//       <p>We collect personal information including your name, phone number, email, location data, and usage data.</p>

//       <h2>2. How We Use Your Information</h2>
//       <p>We use the data to provide and improve services, facilitate communication, process payments, and ensure safety.</p>

//       <h2>3. Sharing of Information</h2>
//       <p>We may share data with other users, service providers, or for legal compliance purposes.</p>

//       <h2>4. Data Security</h2>
//       <p>We implement industry-standard measures to protect your data but cannot guarantee absolute security.</p>

//       <h2>5. Contact Us</h2>
//       <p>If you have any questions, contact our Customer Support.</p>
//     </PrivacyContainer>
//   );
// };

// export default PrivacyPolicy;

import React from "react";
import "../../assets/css/Privacy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1 style={{ textAlign: "center" }}>GoSafari Privacy Policy</h1>
      <p>
        GoSafari ("we," "us," or "our") is committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, share, and protect
        your personal information when you use our ride aggregator platform. By
        using the app, you agree to the collection and use of information under
        this policy.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>
        a. <strong>Personal Information</strong>
      </h3>
      <p>We may collect the following personal information:</p>
      <ul>
        <li>
          <strong>Users:</strong> Name, phone number, email address, profile
          photo (optional), and location data.
        </li>
        <li>
          <strong>Drivers:</strong> Name, phone number, email address, profile
          photo, driver’s license details, vehicle registration information,
          insurance details, and location data.
        </li>
      </ul>

      <h3>
        b. <strong>Usage Data</strong>
      </h3>
      <p>Ride request history, payment details, and interaction logs.</p>
      <p>
        Device information (model, operating system, unique device identifiers).
      </p>
      <p>IP address, browser type, and app version.</p>

      <h3>
        c. <strong>Location Data</strong>
      </h3>
      <p>
        Real-time GPS location for ride-matching, navigation, and safety
        purposes.
      </p>
      <p>
        Background location tracking (with permission) for driver availability
        and ride tracking.
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the collected data to:</p>
      <ul>
        <li>Provide and improve ride-booking services.</li>
        <li>
          Facilitate price negotiation and communication between Users and
          Drivers.
        </li>
        <li>Process payments and manage subscriptions.</li>
        <li>Ensure safety and security for all users.</li>
        <li>Send notifications about ride status, promotions, and updates.</li>
        <li>Comply with legal and regulatory requirements.</li>
      </ul>

      <h2>3. Sharing of Information</h2>
      <p>We may share your information in the following situations:</p>
      <ul>
        <li>
          <strong>With Other Users:</strong>{" "}
          <p>
            Riders receive driver details (name, vehicle info, contact) once a
            ride is confirmed.
          </p>
          <p>
            Drivers receive rider details (name, contact, pickup/drop location)
            for service fulfillment.
          </p>
        </li>
        <li>
          <strong>With Service Providers:</strong> When required by law,
          regulation, or legal processes under Nepali jurisdiction payment
          processing, cloud storage, and analytics.
        </li>
        <li>
          <strong>For Legal Compliance:</strong> When required by law,
          regulation, or legal processes under Nepali jurisdiction.
        </li>
        <li>
          <strong>Business Transfers:</strong> In case of a merger, acquisition,
          or asset sale, user data may be transferred.
        </li>
      </ul>

      <p>We do not sell or rent personal data to third parties.</p>

      <h2>4. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your data,
        including encryption and secure servers. However, no method of
        transmission over the Internet is 100% secure.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your data as long as your account is active or as needed for
        legal and business purposes. You can request the deletion of your
        account and data by contacting us.
      </p>

      <h2>6. Your Rights</h2>
      <strong>
        As per the Privacy Act 2018 (Nepal), you have the right to:
      </strong>
      <p>Access, correct, or delete your data.</p>
      <p>Withdraw consent for data processing (may affect service usage).</p>
      <p>
        File a complaint with regulatory authorities if your privacy rights are
        violated.
      </p>
      <p>To exercise these rights, contact us at Customer Support.</p>

      <h2>7. Third-Party Links</h2>
      <p>
        Our app may contain links to third-party websites or services. We are
        not responsible for the privacy practices of these third parties.
      </p>

      <h2>8. Children’s Privacy</h2>
      <p>
        Our services are not intended for individuals under 18. We do not
        knowingly collect data from minors.
      </p>

      <h2>9. International Data Transfers</h2>
      <p>
        If data is transferred outside Nepal, we ensure it is protected under
        applicable data protection laws.
      </p>

      <h2>10. Changes to This Privacy Policy</h2>
      <p>
        We may update this policy periodically. Changes will be posted in the
        app, and continued use signifies acceptance.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        For any questions or concerns about this Privacy Policy, contact
        Customer Support.
      </p>
      <p style={{ fontWeight: "bold",textAlign:"center" }}>
        By using GoSafari, you acknowledge that you have read and understood
        this Privacy Policy.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
